export default "__VITE_ASSET__D6TMJ_Q5__"